import React from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { projects } from '../../../../Data/projects';
import ProjectBox from './ProjectBox/ProjectBox';
import './Projects.css';

const Projects = () => {
    return (
        <section className="projects-section" id="projects-section">
            <div className="projects-head">
                <h2 className="jsectionHead">Projects</h2>
            </div>
            <div className="project-boxes">
                <Swiper
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 16
                        },
                        900: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        }
                    }}
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    grabCursor
                >
                    {
                        projects.map((project, i) =>
                            <SwiperSlide key={project.name}>
                                <ProjectBox projectInfo={project} i={i} />
                            </SwiperSlide>
                        )
                    }
                </Swiper>
            </div>
        </section>
    );
};

export default Projects;